import env from "@/utils/env";
export default {
  data() {
    return {};
  },
  methods: {
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth * 1.2;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop, data) {
      // 将表头加入数组
      const arr = data.map((x) => x[prop]);
      arr.push(label);
      // 计算每列内容最大的宽度
      const maxWidth = arr.reduce((acc, item) => {
        if (item) {
          const width = this.getTextWidth(item);
          acc = Math.max(acc, width);
        }
        return acc;
      }, 0);
      // 返回最大宽度加上额外的内间距
      return maxWidth + 25 + "px";
    },

    // 封装重置
    resetForm(form) {
      for (const key in form) {
        if (typeof form[key] === "string") {
          form[key] = "";
        } else if (key == "page") {
          form[key] = 1;
        } else {
          form[key] = null;
        }
      }
    },
    // 生成 4 个独立随机数字
    getRandomNumbers() {
      const randomDigits = Array.from({
        length: 4
      }, () => Math.floor(Math.random() * 10));
      return randomDigits;
    },
    // 图片拼接
    imgUrl(url) {
      return env.imgUrl + url;
    },

    // 下载地址拼接
    downloadUrl(url) {
      return env.imgUrl + url;
    },

    // 导出
    exportExcel(url, name) {
      let a = document.createElement("a");
      a.href = this.downloadUrl(url);
      a.download = name;
      a.target = '_blank';
      a.click();
      a.remove();
    },
    // 处理时间戳拿到今天的日期yyyy-mm-dd
    getTodayDate(time) {
      let data
      if (String(time).length != 13) {
        data = new Date(time * 1000);
      } else {
        data = new Date(time);
      }
      return `${data.getFullYear()}-${data.getMonth() + 1}-${data.getDate()}`;
    },
  },
};
